import "./DeckRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import DeckBuildingHeroAnswer from "./sections/DeckBuildingHeroAnswer";
import DeckPlanningDecisions from "./sections/DeckPlanningDecisions";
import DeckTimelineAndTriggers from "./sections/DeckTimelineAndTriggers";
import RemodelingProcess from "./sections/RemodelingProcess";
import DeckFaq from "./sections/DeckFaq";
import OutdoorLivingCta from "./sections/OutdoorLivingCta";
import EstimateRequest from "./sections/EstimateRequest";
import Footer from "@/reusable_sections/Footer";
export default function DeckRemodelingPage() {
  return <div>
      <Header />
      <DeckBuildingHeroAnswer />
      <DeckPlanningDecisions />
      <DeckTimelineAndTriggers />
      <RemodelingProcess />
      <DeckFaq />
      <EstimateRequest />
      <OutdoorLivingCta />
      <Footer />
    </div>;
}